import React, { useEffect, useState } from 'react'
import style from './ScheduleCalendar.module.css'
import dayjs from 'dayjs'
import { getMonday } from 'common/utils/date'
import { Table, TableBody, TableCell, TableHead, TableRow, useMediaQuery } from '@mui/material'
import { ExternAppointmentSchedule } from 'modules/calendar/models/ExternAppointmentSchedule'
import { ScheduleCell } from './ScheduleCell'
import { useIsOpenMenuLeftContext } from 'common/utils/isOpenMenuLeftContext'

const hours = (): string[] => {
  const hourRange = []
  for (let i = 7; i < 23; i++) {
    if (i < 10) {
      hourRange.push('0' + i + ':00')
    } else {
      hourRange.push(i + ':00')
    }
  }
  return hourRange
}

interface ScheduleCalendarProps {
  schedules: ExternAppointmentSchedule[]
  getSchedules: () => void
  handleOpenEditSchedule: (schedule: ExternAppointmentSchedule) => void
  selectedSchedule: ExternAppointmentSchedule | undefined
}

export const SchedulesCalendar: React.FC<ScheduleCalendarProps> = ({
  schedules,
  getSchedules,
  handleOpenEditSchedule,
  selectedSchedule,
}) => {
  const [monday, setMonday] = useState<Date>(getMonday(new Date()))
  const { openMenuLeft } = useIsOpenMenuLeftContext()
  const isMediumDevice = useMediaQuery('(min-width:480px)')

  useEffect(() => {
    const tmpMonday = getMonday(new Date())
    tmpMonday.getTime() !== monday.getTime() && setMonday(tmpMonday)
  }, [])

  const weekDays = (): Date[] => {
    let datesRange = [monday]

    for (let i = 1; i < 7; i++) {
      let newDate = new Date(monday)
      newDate.setDate(monday.getDate() + i)
      datesRange.push(newDate)
    }
    return datesRange
  }

  return (
    <>
      <Table className={style.table}>
        <div
          className={style.tableContentContainer}
          style={{
            width: openMenuLeft ? '' : '100%',
            marginLeft: openMenuLeft ? 30 : '',
            marginRight: openMenuLeft ? 30 : '',
          }}
        >
          <TableHead>
            <TableRow>
              <TableCell className={style.firstHeader}>
                <div className={style.dayEmpty}></div>
              </TableCell>
              {weekDays().map((d) => (
                <TableCell key={d.toString()} className={style.weekDay}>
                  {isMediumDevice
                    ? dayjs(d).locale(navigator.language).format('ddd').toUpperCase()
                    : dayjs(d).locale(navigator.language).format('dd').toUpperCase()}
                </TableCell>
              ))}
            </TableRow>
          </TableHead>
          <TableBody>
            {hours().map((h, i) => (
              <TableRow key={i}>
                <TableCell className={style.hourRow}>
                  <div className={style.hour}>{h}</div>
                </TableCell>
                {weekDays().map((d) => (
                  <TableCell className={style.eventRow} key={String(d) + String(h)}>
                    <ScheduleCell
                      schedules={schedules}
                      currentDay={d}
                      currentHour={h}
                      weekDays={weekDays()}
                      handleOpenEditSchedule={handleOpenEditSchedule}
                    />
                  </TableCell>
                ))}
              </TableRow>
            ))}
          </TableBody>
        </div>
      </Table>
    </>
  )
}
